import "core-js/modules/es.array.push.js";
import { useRoute, useRouter } from "vue-router";
import { onMounted, getCurrentInstance, reactive, computed, onUnmounted, h } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import DynamicInput from "@/components/invoice/dynamicInput.vue";
import clipboard3 from "vue-clipboard3";
import { useMainStore } from "../../pinia/main";
import moment from "moment";
import { phoneDesc } from "@/util";
import { freightUnitTypeMap, orderStatusList, orderStepDesc } from "@/util/type";

import { ElAlert } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/alert/style/css';
export default {
  name: "orderdetail",
  setup() {
    const mainStore = useMainStore();
    const {
      toClipboard
    } = clipboard3();
    const router = useRouter();
    const route = useRoute();
    const internal = getCurrentInstance();
    const globalProperties = internal?.appContext.config.globalProperties;
    const data = reactive({
      isExpend: true,
      orderInfo: {},
      dialogVisible: false,
      origin: [],
      destination: [],
      customerStar: 0
    });
    const dialog = reactive({
      visible: false,
      contractInfo: "",
      type: 1
    });
    onMounted(() => {
      selectOrderInfo();
    });
    const selectOrderInfo = async () => {
      var res = await globalProperties.$api.selectOrderDetail(route.query.orderId);
      data.orderInfo = res;
      data.customerStar = res?.customerInfo?.customerStar;
      data.origin = [res?.loadingInfo?.loadingLon, res?.loadingInfo?.loadingLat];
      data.destination = [res?.loadingInfo?.unloadingLon, res?.loadingInfo?.unloadingLat];
    };

    //联系司机
    const contact = () => {
      ElMessageBox.confirm("点击复制承运人号码", {
        confirmButtonText: "复制号码",
        cancelButtonText: "取消",
        type: "primary"
      }).then(() => {
        toClipboard(data.orderInfo?.customerInfo?.customerPhone);
        ElMessage({
          type: "success",
          message: "已复制"
        });
      }).catch(() => {});
    };

    //取消订单
    const cancelOrder = async () => {
      await globalProperties.$api.applyForCancelOrder(route.query.orderId);
      ElMessage.success("申请成功，待承运人同意");
      selectOrderInfo();
    };
    //获取签约协议并展示弹窗
    const sign = async () => {
      const {
        isSigned,
        type
      } = await globalProperties.$api.selectContractType(route.query.orderId);
      //需要签署的类型1->订单撮合合同 2->长期协议合同
      if (isSigned) {
        return ElMessage.success("您已签约，待承运人完成签约");
      }
      const contractInfo = type == 1 ? await globalProperties.$api.generate(route.query.orderId) : await globalProperties.$api.longTimeContract(route.query.orderId);
      dialog.contractInfo = contractInfo;
      dialog.type = type;
      dialog.visible = true;
    };

    //签约
    const handleContractSign = () => {
      ElMessageBox.confirm("已阅读合同内容并签约？", {
        confirmButtonText: "已读并签约",
        cancelButtonText: "再想想",
        type: "info"
      }).then(async () => {
        dialog.type == 1 ? await globalProperties.$api.contractSign(dialog.contractInfo.contractId) : await globalProperties.$api.signLongTimeContract({
          contractId: dialog.contractInfo.contractId,
          orderId: dialog.orderId
        });
        dialog.visible = false;
        ElMessage.success("签约成功");
        selectOrderInfo();
      }).catch(() => {});
    };

    //申请开票
    const invoice = async () => {
      ElMessageBox.alert("承诺您所发布的运输业务真实有效。业务完成后及时向承运人索取合法有效的发票，并结清费用。如有疑问请联系客服", "提示", {
        confirmButtonText: "我已知悉",
        callback: async action => {
          if (action == "cancel") return;
          var res = await globalProperties.$api.calculateOrderInfo([{
            amount: data.orderInfo?.amountInfo?.driverAmount,
            orderId: route.query.orderId
          }]);
          let editAmount = res[0].invoiceAmount / 100;
          ElMessageBox.confirm("", "", {
            title: "确认信息",
            message: h("div", [h(ElAlert, {
              title: "注意：需承运人提供合法发票后在进行结算！",
              type: "warning",
              closable: false
            }), h("p", `　`), h("p", `企业抬头：${res[0].name}`), h("p", `企业税号：${res[0].taxNo}`), h("p", `应税发生地：${res[0].invoiceAddress}`), h("p", `电子邮箱：${res[0].email}`), h(DynamicInput, {
              initialValue: res[0].invoiceAmount / 100,
              onConfirm: value => {
                editAmount = value;
              }
            })]),
            confirmButtonText: "确定结算",
            // inputPlaceholder: "请输入最终费用（含税）",
            cancelButtonText: "取消"
            // inputValue: res[0].invoiceAmount / 100,
            // inputPattern: /^\d+(\.\d{1,2})?$/,
            // inputErrorMessage: "价格格式有误",
          }).then(async () => {
            const params = {
              list: [{
                amount: Math.floor(Number(editAmount) * 100 * 100) / 100,
                orderId: route.query.orderId
              }]
            };
            var res = await globalProperties.$api.applyInvoice(params);
            if (res) {
              selectOrderInfo();
              ElMessage.success("申请已提交");
            }
          }).catch(() => {});
        }
      });
    };
    //去评价
    const toEvaluate = () => {
      const {
        driverId,
        orderId
      } = data.orderInfo;
      router.push({
        path: "/layout/evaluatedetail",
        query: {
          orderId,
          receiveUserId: driverId
        }
      });
    };
    //查看简介
    const viewProfile = () => {
      router.push({
        path: "/layout/personalprofile",
        query: {
          customerId: data.orderInfo.driverId
        }
      });
    };

    //查看合同信息
    const toViewContract = async () => {
      const a = document.createElement("a");
      a.href = data.orderInfo?.contractInfo?.contractFile;
      a.click();
    };

    //托运人-承运人-同意取消订单
    const agreeCancelOrder = async status => {
      await globalProperties.$api.agreeCancelOrder({
        orderId: route.query.orderId,
        status
      });
      ElMessage.success("操作成功");
      selectOrderInfo();
    };
    const setIsExpend = () => {
      data.isExpend = !data.isExpend;
    };

    //复制承运人收款账
    const copy = async () => {
      await toClipboard(`姓名:${data.orderInfo.driverCardInfo?.personName}-卡号:${data.orderInfo.driverCardInfo?.cardNo}-银行:${data.orderInfo.driverCardInfo?.bankName}`);
      ElMessage({
        type: "success",
        message: "已复制"
      });
    };
    return {
      setIsExpend,
      agreeCancelOrder,
      toEvaluate,
      viewProfile,
      contact,
      toViewContract,
      orderStatusList,
      sign,
      handleContractSign,
      invoice,
      cancelOrder,
      moment,
      data,
      orderStepDesc,
      phoneDesc,
      freightUnitTypeMap,
      dialog,
      copy
    };
  }
};